const validation = {
  WALLET_REQUIRED: 'Please connect wallet',
  TOKEN_IS_REQUIRED: 'Please select token',
  SIGN_IS_REQUIRED: 'Missing signature',
  RECIPIENT_LIST_IS_REQUIRED:
    'Please provide addresses`s list. Your list must contain at least two addresses. Click `_example` for more details.',
  FILE_IS_REQUIRED: 'Please select file',
  ADDRESS_IS_REQUIRED: 'Please provide address',
  PK_IS_REQUIRED: 'Please init private key at first',
  GAS_PARAMS_ARE_REQUIRED: 'Gas parameters are required',

  INVALID_TOKEN: 'Invalid token value',
  INVALID_ADDRESS: 'Invalid address',
  INVALID_AMOUNT: 'Wrong amount',
  INVALID_FILE: 'Invalid format, please use CSV, XLS or XLSX',

  INSUFFICIENT_FUNDS: 'Insufficient funds',
  INSUFFICIENT_APPROVE: 'Insufficient approval amount',
  INSUFFICIENT_TOKEN_BALANCE: 'Insufficient token balance',

  DUPLICATE_ADDRESS: 'Duplicate address',
  FETCH_TOKEN_FAILED: 'Failed to fetch token metadata, please make sure is the token ERC20 standard',
  EMULATION_FAILED: 'The send can not be provided. Please check your recipients list and contract implementation',
}

const rpc = {
  INVALID_RPC_URL: 'Invalid RPC url link, please enter another value',
  REFETCH_REQUEST: 'Please try to refetch the request',
}

const chainId = {
  WRONG_CHAIN_ID: 'Chain Id is different from original. Change network to continue.',
}

const token = {
  TWO_STEP_APPROVE: 'Two step approve required',
}

const wallet = {
  WALLET_REQUIRED: '_connect-wallet-at-first',
  USER_CLOSED_MODAL: '_you-closed-the-connection-modal',
  NO_ACCOUNTS: 'You declined an action in your wallet',
  USER_DENIED: 'You declined an action in your wallet',
  USER_REJECTED: 'You declined an action in your wallet',
  USER_CANCELED: 'You declined an action in your wallet',
  LOCKED_PROVIDER: 'Please, unlock your wallet and try again',
  TRY_ADDING_THE_CHAIN: 'Please add a new chain to the wallet',
  ALREADY_PENDING: 'You already have the pending request in the wallet',
  ALREADY_PROCESSING: 'Previous sending is still processing! Please wait until it is done.',
}

const providerErrorsCodes = {
  userRejectedRequest: 4001,
  unauthorized: 4100,
  unsupportedMethod: 4200,
  disconnected: 4900,
  chainDisconnected: 4901,
}

const transaction = {
  TX_FAIL: 'Transaction failed: unknown reason. Please contact support.',
}

const airdropId = {
  AIRDROP_ID: 'No airdrop Id',
}

const refund = {
  REFUND: 'Transfer cost is higher than private wallet balance',
}

const errors = {
  rpc,
  token,
  wallet,
  refund,
  chainId,
  airdropId,
  validation,
  transaction,
  providerErrorsCodes,
}

export { errors }
